// extracted by mini-css-extract-plugin
export default {"wrapper":"TimesTable_wrapper__paWuW","table":"TimesTable_table__iH8Ih"};